import React from "react";
import { Validity } from "../../interfaces/tip/Validations";
import { InputContainer } from "../InputContainer/InputContainer";
import styles from "./InputText.module.scss";

interface InputTextProps {
  label: string;
  placeholder: string;
  onChange: (text: string) => void;
  value?: string;
  validity?: Validity | false;
}

export const InputText: React.FC<InputTextProps> = ({
  label,
  placeholder,
  onChange,
  value,
  validity,
}) => {
  return (
    <InputContainer label={label} isDropdown={false} validity={validity}>
      <input
        className={styles.InputText}
        type="text"
        value={value}
        placeholder={placeholder}
        onChange={(e: any) => {
          e.preventDefault();
          onChange(e.target.value);
        }}
      />
    </InputContainer>
  );
};
